export default __webpack_public_path__ + "static/mob-img02-2a63d4c9781ad62ebcf300e91376b6b6.png";